import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

interface WorkplaceNameFieldProps<T extends FieldValues> {
  control: Control<T>;
}

/**
 * 勤務先(医療機関名)の手入力欄。
 * NOTE:人材紹介企業は自組織が勤務先ではないため、求人ごとに勤務先を入力させる
 */
export function WorkplaceNameField<T extends FieldValues>({
  control,
}: WorkplaceNameFieldProps<T>) {
  const theme = useTheme();
  // NOTE:呼び出し元のフォーム型は異なるが、いずれもworkplaceNameを持つ前提でキャストする
  const workplaceNameName = 'workplaceName' as Path<T>;
  return (
    <Controller
      name={workplaceNameName}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          inputRef={field.ref}
          InputProps={{
            sx: { bgcolor: theme.palette.common.white },
          }}
          error={!!error}
          helperText={error?.message}
          placeholder="勤務先（医療機関名）を入力"
          fullWidth
        />
      )}
    />
  );
}
